import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Image",
          value: "inventoryImage",
        },
        {
          text: "Item",
          value: "Item.name",
        },
        {
          text: "Type",
          value: "Item.type",
        },
        {
          text: "Price",
          value: "inventoryPrice",
        },
        {
          text: "Quantity",
          value: "quantity",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Image",
          value: "inventoryImage",
        },
        {
          text: "Item",
          value: "Item.name",
        },
        {
          text: "quantity",
          value: "quantity",
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "model",
        key: "itemId",
        server: "game",
        name: "Item",
        model: "item",
        optionValue: "id",
        defaultValue: 1,
      },
      {
        type: "number",
        key: "quantity",
        name: "Quantity",
        min: 0,
        defaultValue: 1,
      },
    ],
    rules: {
      itemId: [(v) => !!v || "Item is required"],
      quantity: [(v) => !!v || "Quantity is required"],
    },
  },
  edit: false,
  delete: true,
};
